import ProductAttr from './ProductAttr';
import Button from './Button';
import Currency from './currency';
import Catelog from './catalog';
export default class PanelDetail {
  private _Sku: string;
  public get Sku(): string {
    return this._Sku;
  }
  public set Sku(v: string) {
    this._Sku = v;
  }
  private _Name: string;
  public get Name(): string {
    return this._Name;
  }
  public set Name(v: string) {
    this._Name = v;
  }

  private _Detail: string;
  public get Detail(): string {
    return this._Detail;
  }
  public set Detail(v: string) {
    this._Detail = v;
  }
  /**
   * @param _overView 可选
   */
  private _OverView: string;
  public get OverView(): string {
    return this._OverView;
  }
  public set OverView(v: string) {
    this._OverView = v;
  }
  private _Specification: string;
  public get Specification(): string {
    return this._Specification;
  }
  public set Specification(v: string) {
    this._Specification = v;
  }
  private _Code: string;
  public get Code(): string {
    return this._Code;
  }
  public set Code(v: string) {
    this._Code = v;
  }
  private _ListPrice: number;
  public get ListPrice(): number {
    return this._ListPrice;
  }
  public set ListPrice(v: number) {
    this._ListPrice = v;
  }
  private _SalePrice: number;
  public get SalePrice(): number {
    return this._SalePrice;
  }
  public set SalePrice(v: number) {
    this._SalePrice = v;
  }
  private _DefaultListPrice: number;
  public get DefaultListPrice(): number {
    return this._DefaultListPrice;
  }
  public set DefaultListPrice(v: number) {
    this._DefaultListPrice = v;
  }

  private _DefaultSalePrice: number;
  public get DefaultSalePrice(): number {
    return this._DefaultSalePrice;
  }
  public set DefaultSalePrice(v: number) {
    this._DefaultSalePrice = v;
  }
  private _AttrList: ProductAttr[][];
  public get AttrList(): ProductAttr[][] {
    return this._AttrList;
  }
  public set AttrList(v: ProductAttr[][]) {
    this._AttrList = v;
  }
  private _ExtAttrList: ProductAttr[][];
  public get ExtAttrList(): ProductAttr[][] {
    return this._ExtAttrList;
  }
  public set ExtAttrList(v: ProductAttr[][]) {
    this._ExtAttrList = v;
  }
  private _ProductStatus: number;
  public get ProductStatus(): number {
    return this._ProductStatus;
  }
  public set ProductStatus(v: number) {
    if (v === undefined || v === null) v = -1;
    if (v === 0) {
      this.button = [new Button('addToCart', 'positive', 'large', 'addToCart'), new Button('buy', 'nagative', 'large', 'buy')];
    } else if (v === 1) {
      this.button = [new Button('offSale', 'positive', 'large', 'offSale')];
    } else if (v === 2) {
      this.button = [new Button('SaleOut', 'positive', 'large', 'SaleOut')];
    } else if (v === 3) {
      this.button = [new Button('purchasing', 'positive', 'large', 'Purchasing'), new Button('notifyMe', 'nagative', 'large', 'notifyMe')];
    }
    this._ProductStatus = v;
  }

  private _Currency: Currency;
  public get Currency(): Currency {
    return this._Currency;
  }
  public set Currency(v: Currency) {
    this._Currency = v;
  }
  private _DefaultCurrency: Currency = new Currency();
  public get DefaultCurrency(): Currency {
    return this._DefaultCurrency;
  }
  public set DefaultCurrency(v: Currency) {
    this._DefaultCurrency = v;
  }
  private _MinPurQty: number;
  public get MinPurQty(): number {
    return this._MinPurQty;
  }
  public set MinPurQty(v: number) {
    this._MinPurQty = v;
  }

  private _MaxPurQty: number;
  public get MaxPurQty(): number {
    return this._MaxPurQty;
  }
  public set MaxPurQty(v: number) {
    this._MaxPurQty = v;
  }
  private _CatId: number;
  public get CatId(): number {
    return this._CatId;
  }
  public set CatId(v: number) {
    this._CatId = v;
  }

  private _CatalogTree: Catelog[];
  public get CatalogTree(): Catelog[] {
    return this._CatalogTree;
  }
  public set CatalogTree(v: Catelog[]) {
    this._CatalogTree = v;
  }
  private _IsFavorite: boolean;
  public get IsFavorite(): boolean {
    return this._IsFavorite;
  }
  public set IsFavorite(v: boolean) {
    this._IsFavorite = v;
  }
  private _Score: number;
  public get Score(): number {
    return this._Score;
  }
  public set Score(v: number) {
    this._Score = v;
  }

  private _UnitInfo: object;
  public get UnitInfo(): object {
    return this._UnitInfo;
  }
  public set UnitInfo(v: object) {
    this._UnitInfo = v;
  }
  private _YoutubeLink: string;
  public get YoutubeLink(): string {
    return this._YoutubeLink;
  }
  public set YoutubeLink(v: string) {
    this._YoutubeLink = v;
  }
  private _SoldOutAttrComboList: Catelog[];
  public get SoldOutAttrComboList(): Catelog[] {
    return this._SoldOutAttrComboList;
  }
  public set SoldOutAttrComboList(v: Catelog[]) {
    this._SoldOutAttrComboList = v;
  }
  private _AttrComboImgList: Catelog[];
  public get AttrComboImgList(): Catelog[] {
    return this._AttrComboImgList;
  }
  public set AttrComboImgList(v: Catelog[]) {
    this._AttrComboImgList = v;
  }
  private _Permission: string;
  public get Permission(): string {
    return this._Permission;
  }
  public set Permission(v: string) {
    this._Permission = v;
  }
  private _negotiable: boolean;
  public get negotiable(): boolean {
    return this._negotiable;
  }
  public set negotiable(v: boolean) {
    this._negotiable = v;
  }

  private _negotiateMinQty: number;
  public get negotiateMinQty(): number {
    return this._negotiateMinQty;
  }
  public set negotiateMinQty(v: number) {
    this._negotiateMinQty = v;
  }
  private _CatPathName: string;
  public get CatPathName(): string {
    return this._CatPathName;
  }
  public set CatPathName(v: string) {
    this._CatPathName = v;
  }
  private _AdditionalImage: Catelog[];
  public get AdditionalImage(): Catelog[] {
    return this._AdditionalImage;
  }
  public set AdditionalImage(v: Catelog[]) {
    this._AdditionalImage = v;
  }
  private _Ingredient: string;
  public get Ingredient(): string {
    return this._Ingredient;
  }
  public set Ingredient(v: string) {
    this._Ingredient = v;
  }

  private _SeoDescription: string;
  public get SeoDescription(): string {
    return this._SeoDescription;
  }
  public set SeoDescription(v: string) {
    this._SeoDescription = v;
  }

  private _SeoKeywords: string;
  public get SeoKeywords(): string {
    return this._SeoKeywords;
  }
  public set SeoKeywords(v: string) {
    this._SeoKeywords = v;
  }



  private _ProductDimension: string;
  public get ProductDimension(): string {
    return this._ProductDimension;
  }
  public set ProductDimension(v: string) {
    this._ProductDimension = v;
  }

  private _SeoTitle: string;
  public get SeoTitle(): string {
    return this._SeoTitle;
  }
  public set SeoTitle(v: string) {
    this._SeoTitle = v;
  }

  private _Package: string;
  public get Package(): string {
    return this._Package;
  }
  public set Package(v: string) {
    this._Package = v;
  }





  private _Img_L: string;
  public get Img_L(): string {
    return this._Img_L;
  }
  public set Img_L(v: string) {
    this._Img_L = v;
  }
  public button: Button[] = [];
  constructor(sku: string, name: string, detail: string, code: string, Permission: string, listPrice: number, salePrice: number, DefaultListPrice: number, DefaultSalePrice: number, _YoutubeLink: string, overView: string = '', Specification: string = '', CatPathName: string, attrList: ProductAttr[][] = [], extAttrList: ProductAttr[][] = [], productStatus: number = 3, currency: Currency = new Currency(), DefaultCurrency: Currency = new Currency(), _MaxPurQty: number = 0, _MinPurQty: number = 1, _CatId = 0, _CatalogTree = [], _IsFavorite: boolean = false, _negotiable: boolean = false, _Score: number = 0, _negotiateMinQty: number = 0, _UnitInfo: object = {}, _SoldOutAttrComboList = [], _AttrComboImgList = [], _AdditionalImage = [], Ingredient: string = '', SeoDescription: string = '', SeoKeywords: string = '', Img_L: string = '', ProductDimension: string = '', SeoTitle: string = '', Package: string = '') {
    this._Name = name;
    this._Sku = sku;
    this._Detail = detail
    this._Code = code;
    this._ListPrice = listPrice;
    this._SalePrice = salePrice;
    this._ProductStatus = productStatus;
    this._OverView = overView;
    this._Specification = Specification;
    this._AttrList = attrList;
    this._ExtAttrList = extAttrList;
    this._Currency = currency;
    this._MaxPurQty = _MaxPurQty;
    this._MinPurQty = _MinPurQty;
    this._CatId = _CatId;
    this._CatalogTree = _CatalogTree;
    this._IsFavorite = _IsFavorite;
    this._negotiable = _negotiable;
    this._Score = _Score;
    this._negotiateMinQty = _negotiateMinQty;
    this._UnitInfo = _UnitInfo;
    this._YoutubeLink = _YoutubeLink;
    this._DefaultListPrice = DefaultListPrice;
    this._DefaultSalePrice = DefaultSalePrice;
    this._DefaultCurrency = DefaultCurrency;
    this._SoldOutAttrComboList = _SoldOutAttrComboList;
    this._AttrComboImgList = _AttrComboImgList;
    this._Permission = Permission;
    this._CatPathName = CatPathName;
    this._AdditionalImage = _AdditionalImage;
    this._Ingredient = Ingredient;
    this._SeoDescription = SeoDescription;
    this._SeoKeywords = SeoKeywords;
    this._Img_L = Img_L;
    this._ProductDimension = ProductDimension;
    this._SeoTitle = SeoTitle;
    this._Package = Package;
  }
}
